import React from 'react';
import RecordsProgressive from './records-progressive';

const WithdrawRecords = () => {
  return <RecordsProgressive type="withdraw" />;
};

export default WithdrawRecords;
